(function () {

    'use strict';

    angular.module('asys')
        .service('AngebotUtilsService', AngebotUtilsService);

    AngebotUtilsService.$inject = [
        '$injector',
        '$sce',
        '$location',
        '$window',
        '$state',
        '$q',
        '$http',
        '$httpParamSerializerJQLike',
        '$cookies',
        'lodash',
        'moment',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService',
        'FormatUtilsService',
        'IntegrationService',
        'MiscUtilsService',
        'IdentityTypeUtilsService',
        'AuthenticationService',
        'NavigationService',
        'ApiService',
        'SchluesselWerteUtilsService'
    ];
    function AngebotUtilsService($injector, $sce, $location, $window, $state, $q, $http, $httpParamSerializerJQLike, $cookies, _, moment, AppConfig, AngebotModel, BasisAngebotService, FormatUtilsService, IntegrationService, MiscUtilsService, IdentityTypeUtilsService, AuthenticationService, NavigationService, ApiService, SchluesselWerteUtilsService) {
        var that = this,
            regexFin = /^([0-9]|[A-Z]){8,17}$/i,
            vertragsnummerRegExp = /V[0-9]{2}\s[0-9]{3}\s[0-9]{3}\/[0-9]{3}/g,
            $sessionStorage,
            directRedirectLoggedIn = false;

        $sessionStorage = $injector.has('$sessionStorage') && $injector.get('$sessionStorage') || {};

        that.isTarifauskunftsdatumInTarifgeneration = isTarifauskunftsdatumInTarifgeneration;
        that.createSbLg = createSbLg;
        that.getSbLgTextFromZasZap = getSbLgTextFromZasZap;
        that.getAntragstellerDatenAenderbarMap = getAntragstellerDatenAenderbarMap;
        that.getErsatzgeschaeftDatenAenderbarMap = getErsatzgeschaeftDatenAenderbarMap;
        that.getAngebotspartnerNameAsString = getAngebotspartnerNameAsString;
        that.getAngebotspartnerAdresseAsString = getAngebotspartnerAdresseAsString;
        that.getGegenstandAdresseAsString = getGegenstandAdresseAsString;
        that.getPdfLinks = getPdfLinks;
        that.getTarifdetailNames = getTarifdetailNames;
        that.getImprintUrlByMandant = getImprintUrlByMandant;
        that.getProduktgruppeName = getProduktgruppeName;
        that.isFahrgestellnummerValid = isFahrgestellnummerValid;
        that.isUploadRequired = isUploadRequired;
        that.wechsleTarifgeneration = wechsleTarifgeneration;
        that.getUberschriftZusatztext = getUberschriftZusatztext;
        that.isWertAnonymisiert = isWertAnonymisiert;
        that.isAngebotAnonymisiert = isAngebotAnonymisiert;
        that.isBlockAngebotFortsetzenErlaubt = isBlockAngebotFortsetzenErlaubt;
        that.isBlockAngebotProduktinfosErlaubt = isBlockAngebotProduktinfosErlaubt;
        that.isBlockPksLoginErlaubt = isBlockPksLoginErlaubt;
        that.isPersonVolljaehrig = isPersonVolljaehrig;
        that.getAccordionsStepAntragPruefenDefaultState = getAccordionsStepAntragPruefenDefaultState;
        that.getUid = getUid;
        that.getTrackingParameter = getTrackingParameter;
        that.enrichAlertMessages = enrichAlertMessages;
        that.getVertragsnummerFromApiNachricht = getVertragsnummerFromApiNachricht;
        that.getErgebnisSeiteTitle = getErgebnisSeiteTitle;
        that.isTelefonnummerValide = isTelefonnummerValide;
        that.createVouchers = createVouchers;
        that.setRedirectUrlAfterPksLogin = setRedirectUrlAfterPksLogin;
        that.handleCloseAndNavigation = handleCloseAndNavigation;
        that.getFortsetzenLink = getFortsetzenLink;
        function isTarifauskunftsdatumInTarifgeneration(tarifauskunftsdatum, tarif) {
            if (!tarif || !tarifauskunftsdatum || !tarif.gueltigVon || !tarif.gueltigBis) {
                return true;
            }

            var gueltigVonMoment = moment(tarif.gueltigVon, AppConfig.API.dateFormat),
                gueltigBisMoment = moment(tarif.gueltigBis, AppConfig.API.dateFormat),
                tarifauskunftsdatumMomemnt = moment(tarifauskunftsdatum, AppConfig.API.dateFormat);
            return moment(tarifauskunftsdatumMomemnt).isBetween(gueltigVonMoment, gueltigBisMoment, null, '[]');
        }
        function createSbLg(type, code) {
            var codeIdentityType,
                typeIdentityType = {
                    selbstbeteiligung: 'SELBSTBETEILIGUNGSCODE',
                    leistungsgrenze: 'LEISTUNGSGRENZENCODE'
                };

            if (MiscUtilsService.isAtLeastOneEmpty(type, typeIdentityType[type], code)) {
                return {};
            }

            codeIdentityType = IdentityTypeUtilsService.isIdentityType(code) ? code : IdentityTypeUtilsService.create(typeIdentityType[type], code);

            return {
                code: codeIdentityType
            };
        }
        function getSbLgTextFromZasZap(baustein, type, code, removePrefix, useBetrag) {
            var zasZapType = {
                    selbstbeteiligung: {
                        regexReplace: /^\s*Selbstbeteiligung:\s*\n*/,
                        path: 'selbstbeteiligungen'
                    },
                    leistungsgrenze: {
                        regexReplace: /^\s*Versicherungssumme:\s*\n*/,
                        path: 'leistungsgrenzen'
                    }
                },
                text;

            if (MiscUtilsService.isAtLeastOneEmpty(baustein, type, code)) {
                return;
            }

            text = (_.find(_.get(baustein, 'zasZapAnfrageErgebnis.' + zasZapType[type].path), {
                code: {
                    id: code
                }
            }) || {})[useBetrag ? 'betrag' : 'angebotstext'];

            if (MiscUtilsService.isEmpty(text)) {
                return null;
            }
            if (useBetrag) {
                return text;
            }

            return removePrefix ? text.replace(zasZapType[type].regexReplace, '') : text;
        }
        function getAntragstellerDatenAenderbarMap(angebot) {
            var datenAenderbarMap = {},
                antragstellerPropsWennLeerAenderbar = 'anrede titel geburtsdatum strasse ort geburtsort geburtsland'.split(' '),
                antragstellerPropsImmerAenderbar = 'arbeitgeber beruf bic iban ibanQualitaetscode imOeffentlichemDienstTaetig kommunikationsmedien taetigkeitsschluessel familienstand staatsangehoerigkeit'.split(' '),
                partnerIcis = _.get(angebot, 'partnerIcis');

            function _isAenderbar(key, value) {
                var isEmpty = MiscUtilsService.isEmpty(value),
                    isAenderbarType;

                if (BasisAngebotService.isAngebotAnonym(angebot)) {
                    return true;
                }

                isAenderbarType = _.includes(antragstellerPropsImmerAenderbar, key) ? 'always' : _.includes(antragstellerPropsWennLeerAenderbar, key) ? 'empty' : 'none';

                if (isAenderbarType === 'always') {
                    return true;
                }

                if (isEmpty && isAenderbarType === 'empty') {
                    return true;
                }

                return false;
            }

            if (MiscUtilsService.isEmpty(partnerIcis)) {
                return datenAenderbarMap;
            }

            _.forOwn(partnerIcis, function (value, key) {
                datenAenderbarMap[key] = _isAenderbar(key, value);
            });

            _.each(_.union(antragstellerPropsImmerAenderbar, antragstellerPropsWennLeerAenderbar), function (key) {
                if (!_.has(datenAenderbarMap, key)) {
                    datenAenderbarMap[key] = 'always';
                }
            });

            return datenAenderbarMap;
        }
        function getErsatzgeschaeftDatenAenderbarMap(angebot, angebotInitial) {
            var AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (_.isFunction(AngebotSpezifischService.getErsatzgeschaeftDatenAenderbarMap)) {
                return AngebotSpezifischService.getErsatzgeschaeftDatenAenderbarMap(angebot, angebotInitial);
            }

            return {};
        }
        function getAngebotspartnerNameAsString(obj, angebotspartner, properties) {
            var angebotspartnerObj = BasisAngebotService.getAngebotspartner(obj, angebotspartner);

            return FormatUtilsService.toPartnerString(angebotspartnerObj, properties);
        }
        function getAngebotspartnerAdresseAsString(angebot, angebotspartner, options) {
            var angebotspartnerObj = BasisAngebotService.getAngebotspartner(angebot, angebotspartner),
                adresse = {};

            adresse.strasse = angebotspartnerObj.strasse;
            adresse.postleitzahl = angebotspartnerObj.postleitzahl;
            adresse.ort = angebotspartnerObj.ort;
            adresse.land = angebotspartnerObj.land;

            return FormatUtilsService.toAdresseString(adresse, options);
        }
        function getGegenstandAdresseAsString(gegenstand) {
            var adresse = {};

            adresse.strasse = gegenstand.strasse;
            adresse.postleitzahl = gegenstand.postleitzahl;
            adresse.ort = gegenstand.ort;
            adresse.land = gegenstand.land;

            return FormatUtilsService.toAdresseString(adresse);
        }
        function getPdfLinks(angebot, tarifgeneration) {
            var AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                pdfLinks = {
                    produktGruppen: {},
                    vertragsunterlagen: []
                },
                aktiveProduktGruppen = BasisAngebotService.getProduktGruppen(angebot, true),
                linkVertragsunterlagenText,
                pdfInfos;

            _.each(aktiveProduktGruppen, function (produktGruppe) {
                pdfInfos = AngebotSpezifischService.getPdfInfos(angebot, produktGruppe, aktiveProduktGruppen);

                if (!pdfInfos || _.find(pdfLinks.produktGruppen, ['pdfName', pdfInfos.pdfName])) {
                    return;
                }

                if (MiscUtilsService.isEmpty(pdfLinks.produktGruppen[produktGruppe])) {
                    pdfLinks.produktGruppen[produktGruppe] = pdfInfos;

                    linkVertragsunterlagenText = 'Vertragsunterlagen ';

                    pdfLinks.produktGruppen[produktGruppe].produktGruppe = produktGruppe;

                    if (pdfInfos.vertragsunterlagenVorhanden) {
                        pdfLinks.produktGruppen[produktGruppe].vertragsunterlagen = {
                            url: FormatUtilsService.replace(AppConfig.APP.links.vertragsunterlagen, $window.location.origin + AppConfig.APP.urls.root, pdfInfos.pdfNameVertragsunterlagen || pdfInfos.pdfName),
                            linkText: linkVertragsunterlagenText + pdfInfos.linkProduktGruppeText,
                            vertragsunterlagenInhaltTpl: pdfInfos.vertragsunterlagenInhaltTpl,
                            trackingTarget: 'vertragsunterlagen_' + (pdfInfos.pdfNameVertragsunterlagen || pdfInfos.pdfName)
                        };
                        pdfLinks.vertragsunterlagen.push(pdfLinks.produktGruppen[produktGruppe].vertragsunterlagen);
                    }

                    if (pdfInfos.linkProduktseite) {
                        pdfInfos.linkProduktseiteDesc = _.replace(pdfInfos.linkProduktseite, /(http|https):\/\/www[1-4]?\./gi, '');
                    }
                }
            });

            return pdfLinks;
        }
        function getImprintUrlByMandant(angebot, type) {
            var imprintUrls = {
                    footer: 'angebot/partials/vertragspartnerMnd{0}.html',
                    antragpruefen: 'reiter/antragpruefen/partials/vertragspartnerMnd{0}.html'
                },
                mandant = _.get(angebot, 'mandant.id');

            if (!mandant || !imprintUrls[type]) {
                return;
            }

            return FormatUtilsService.replace(imprintUrls[type], mandant);
        }
        function getTarifdetailNames(angebot, shouldIncludeProduktGruppen) {
            var AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                produktGruppen = BasisAngebotService.getProduktGruppen(angebot, true),
                tarifdetails = [];

            shouldIncludeProduktGruppen = !_.isBoolean(shouldIncludeProduktGruppen) ? true : false;

            if (shouldIncludeProduktGruppen) {
                tarifdetails = _.map(produktGruppen, function (val) {
                    return 'produktGruppe' + getProduktgruppeName(val);
                });
            }

            if (_.isFunction(AngebotSpezifischService.getTarifdetailNames)) {
                tarifdetails = _.concat(tarifdetails, AngebotSpezifischService.getTarifdetailNames(angebot, produktGruppen));
            }

            return tarifdetails;
        }
        function getProduktgruppeName(produktGruppe) {
            return _.upperFirst(_.camelCase(produktGruppe));
        }
        function isFahrgestellnummerValid(fahrgestellnummer, regex, options) {
            if (MiscUtilsService.isEmpty(fahrgestellnummer)) {
                return true;
            }

            regex = regex || regexFin;
            options = options || {};
            if (options.nurGleicheZeichen !== false && _.size(fahrgestellnummer) >= 2 && _.union(_.split(fahrgestellnummer, '')).length <= 1) {
                return false;
            }
            return (regex).test(fahrgestellnummer);
        }
        function isUploadRequired(angebot) {
            var AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (angular.isFunction(AngebotSpezifischService.isUploadRequired)) {
                return AngebotSpezifischService.isUploadRequired(angebot);
            }

            return false;
        }
        function wechsleTarifgeneration(tarifauskunftsdatum, tarifkuerzelNeu, tarifkuerzelAlt) {
            if (MiscUtilsService.isAtLeastOneEmpty(tarifauskunftsdatum, tarifkuerzelNeu, tarifkuerzelAlt) || _.toLower(tarifkuerzelAlt) === _.toLower(tarifkuerzelNeu)) {
                return;
            }

            var $analytics = $injector.has('$analytics') && $injector.get('$analytics'),
                regexTarifkuerzelUrl = new RegExp('(?!/)((?:\\w*?)?' + tarifkuerzelAlt + ')+(?!/)?', 'gi'),
                subpathTarifkuerzelNeu = (/^\D+/.test(tarifkuerzelNeu) ? '' : (tarifkuerzelAlt.match(/^\D+/) || [''])[0]) + tarifkuerzelNeu;

            if ($analytics) {
                $analytics.eventTrack('link', {
                    target: 'Angebot-Tg-Wechsel'
                });
            }

            $location.search({
                dat: tarifauskunftsdatum
            });
            $location.replace();
            $window.location.href = $location.absUrl().replace(regexTarifkuerzelUrl, _.toLower(subpathTarifkuerzelNeu));
        }
        function getUberschriftZusatztext(angebot, type) {
            var AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (_.isFunction(AngebotSpezifischService.getUberschriftZusatztext)) {
                return AngebotSpezifischService.getUberschriftZusatztext(angebot, type);
            }

            return null;
        }
        function isWertAnonymisiert(value, type) {
            var angebotModel = AngebotModel.get(),
                v = MiscUtilsService.getValueCustomObject(value),
                regexIbanAnonymisiert = new RegExp('^[A-Z]{2}[0-9]{2}[X]{4,}[0-9]{2}', 'gi'),
                regexEmailAnonymisiert = new RegExp('^.{1}[X]{0,}@.*', 'g'),
                regexNameAnonymisiert = new RegExp('(XX){1,}', 'g'),
                regexPlzAnonymisiert = new RegExp('(XX){1}\\d{3}', 'g');

            if (!isAngebotAnonymisiert(angebotModel.angebot) || MiscUtilsService.isEmpty(value)) {
                return false;
            }

            if (type === 'IBAN') {
                return regexIbanAnonymisiert.test(v);

            } else if (type === 'EMAIL') {
                return regexEmailAnonymisiert.test(v);

            } else if (type === 'NAME') {
                return regexNameAnonymisiert.test(v);
            } else if (type === 'PLZ') {
                return regexPlzAnonymisiert.test(v);
            } else {
                return /^XXX.*/.test(v);
            }
        }
        function isAngebotAnonymisiert(angebot) {
            return (
                _.get(angebot, 'anonymisiert') && // Angebot wird bei anonymer Sitzung anonymisiert
                !AuthenticationService.isTokenLogin() // Anonyme-Sitzung
            );
        }
        function isBlockAngebotFortsetzenErlaubt(angebotModel, options) {
            angebotModel = angebotModel || {};
            options = options || {};
            return (
                (
                    (
                        BasisAngebotService.beitraegeVorhanden(angebotModel.angebot) &&
                        !options.ignoreBeitraegeVorhanden
                    ) ||
                    options.ignoreBeitraegeVorhanden
                ) &&
                BasisAngebotService.isAngebotAenderbar(angebotModel.angebot, 'ANTRAG') &&
                (
                    (
                        !angebotModel.wurdeGeladen &&
                        !options.ignoreWurdeGeladen
                    )
                    || options.ignoreWurdeGeladen
                )
            );
        }
        function isBlockAngebotProduktinfosErlaubt(angebotModel, options) {
            angebotModel = angebotModel || {};
            options = options || {};

            return (
                (
                    (
                        BasisAngebotService.beitraegeVorhanden(angebotModel.angebot) &&
                        !options.ignoreBeitraegeVorhanden
                    ) ||
                    options.ignoreBeitraegeVorhanden
                ) &&
                BasisAngebotService.isAngebotAenderbar(angebotModel.angebot, 'ANTRAG') &&
                (
                    !angebotModel.wurdeGeladen ||
                    (
                        angebotModel.wurdeGeladen && BasisAngebotService.isAngebotAenderbar(angebotModel.angebotOriginal, 'ANGEBOT')
                    )
                )
            );
        }
        function isBlockPksLoginErlaubt(angebotModel) {
            angebotModel = angebotModel || {};

            var AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebotModel.angebot) + 'Service');

            if (
                NavigationService.get(_.get($state, '$current.name')).pksLogin !== true ||
                $window.sessionStorage && !$window.sessionStorage.getItem('iframeReload') ||
                directRedirectLoggedIn === true ||
                $sessionStorage.reloadAnonym === true
            ) {
                return false;
            }

            if (_.isFunction(AngebotSpezifischService.isBlockPksLoginErlaubt)) {
                return AngebotSpezifischService.isBlockPksLoginErlaubt(angebotModel);
            }

            return (
                !angebotModel.wurdeGeladen &&
                !angebotModel.wurdeKopiert &&
                BasisAngebotService.isAngebotAenderbar(angebotModel.angebot, 'ANGEBOT') &&
                !BasisAngebotService.isErsatzgeschaeft(angebotModel.angebot)
            );
        }
        function isPersonVolljaehrig(stichtag, geburtsdatum) {
            return moment(stichtag, AppConfig.API.dateFormat).diff(moment(geburtsdatum, AppConfig.API.dateFormat), 'years') >= 18;
        }
        function getAccordionsStepAntragPruefenDefaultState(angebot) {
            var AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (_.isFunction(AngebotSpezifischService.getAccordionsStepAntragPruefenDefaultState)) {
                return AngebotSpezifischService.getAccordionsStepAntragPruefenDefaultState(angebot);
            }

            return {
                angebotAllgemein: true,
                tarifmerkmale: true,
                berechneteBeitraege: true,
                antragAllgemein: true,
                antragsdaten: true,
                antragDateien: true,
                antragsteller: true,
                vertragspartner: true
            };
        }

        function getUid(angebotModel) {
            var uid;

            if (_.get(angebotModel, 'angebot.orderId')) {
                uid = _.get(angebotModel, 'angebot.orderId');
            } else {
                uid = MiscUtilsService.guid();
                _.set(angebotModel, 'orderId', uid);
                _.set(angebotModel, 'angebot.orderId', uid);
            }

            return uid;
        }
        function getTrackingParameter(angebot, trackingProvider, trackingEvent, variableName, trackingType) {
            var AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (trackingProvider === 'hurra') {
                if (variableName === 'u5') {
                    if (AngebotSpezifischService && _.isFunction(AngebotSpezifischService.getTrackingParameter)) {
                        return AngebotSpezifischService.getTrackingParameter(angebot, trackingProvider, trackingEvent, variableName, trackingType);
                    }

                    return null;
                }
            }
        }

        function enrichAlertMessages(alerts, type) {
            var msg,
                vertragsnummern;

            _.forEach(alerts, function (alert) {
                if (type === 'ABSCHLUSS') {
                    msg = $sce.getTrustedHtml(alert.message);

                    vertragsnummern = getVertragsnummerFromApiNachricht(msg, false);

                    if (
                        (
                            AuthenticationService.getSession().tokenLoginSession ||
                            IntegrationService.getIntegrationParams().isTokenLogin
                        ) &&
                        !MiscUtilsService.isAppModus() &&
                        _.size(vertragsnummern) > 0
                    ) {
                        _.forEach(vertragsnummern, function (vertragsnummer) {
                            msg = msg.replace(vertragsnummer, '<a href="' + FormatUtilsService.replace(AppConfig.APP.urls.kundenportalVertragDetails, _.replace(vertragsnummer, /[^0-9]/g, '')) + '" target="_blank">$&</a>');
                        });

                        alert.message = msg;
                    }
                }
            });
        }
        function getVertragsnummerFromApiNachricht(text, convertToNumber) {
            var vertragsnummern = [];

            if (vertragsnummerRegExp.test(text)) {
                vertragsnummern = text.match(vertragsnummerRegExp);
            }

            if (convertToNumber && _.size(vertragsnummern) > 0) {
                _.map(vertragsnummern, function (vertragsnummer) {
                    return _.replace(vertragsnummer, /[^0-9]/g, '');
                });
            }

            return vertragsnummern;
        }
        function getErgebnisSeiteTitle(angebot) {
            var AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                zahlweiseWert = BasisAngebotService.getZahlweise(angebot).wert,
                angebotstyp = BasisAngebotService.getAngebotstyp(angebot),
                title = 'Ihr persönlicher Beitrag';

            if (_.isFunction(AngebotSpezifischService.getErgebnisSeiteTitle)) {
                return AngebotSpezifischService.getErgebnisSeiteTitle(angebot);
            }

            switch (zahlweiseWert) {
            case '51':
                if (angebotstyp === 'VKM') {
                    title += '';
                } else if (
                    angebotstyp === 'KFZ' &&
                    _.get(angebot, 'angebotsgegenstandFahrzeug.saisonfahrzeug') === true
                ) {
                    title = 'Ihr Saisonbeitrag';
                } else {
                    title = 'Ihr Jahresbeitrag';
                }
                break;
            case '50':
                title = 'Ihr Halbjahresbeitrag';
                break;
            case '49':
                title = 'Ihr Quartalsbeitrag';
                break;
            case '48':
                title = 'Ihr Monatsbeitrag';
                break;
            case '47':
                title = 'Ihr Einmalbeitrag';
                break;
            }

            return title;
        }
        function isTelefonnummerValide(kome) {
            return $q(function (resolve, reject) {
                if (MiscUtilsService.isEmpty(kome) || MiscUtilsService.isEmpty(kome.wert) || !_.includes(['TELM', 'TELP', 'TELG'], _.get(kome, 'art.wert'))) {
                    return resolve(true);
                }

                return $http({
                    method: 'GET',
                    url: AppConfig.API.services.angTelefonnummerValidieren,
                    cache: true,
                    params: {
                        rufnummer: kome.wert,
                        kommunikationsweg: _.get(kome, 'art.wert')
                    },
                    globalErrorsIgnore: {
                        errors: true,
                        nachrichten: true
                    },
                    httpErrorsIgnore: true
                }).then(function () {
                    return resolve(true);
                }).catch(function (response) {
                    return reject(ApiService.getApiExceptionsFromResponse(response)[0]);
                });
            });
        }
        function createVouchers(angebot, options) {
            options = options || {};

            var noopPromise = function () {
                    return $q(function (resolve) {
                        resolve([]);
                    });
                },
                voucherServices = [],
                angebotsnummer = BasisAngebotService.getAngebotsnummer(angebot),
                angebotsToken = BasisAngebotService.getToken(angebot),
                antragstellerEmailPrivat = _.get(BasisAngebotService.getKommunikationsmedium(angebot, 'antragsteller', 'EMAILP'), 'wert');
            if (
                _.get(AppConfig.ANGEBOT, 'vouchers.POLO') &&
                _.get(AppConfig.ANGEBOT, 'vermittlernummern.POLO') === _.get(angebot, 'allgemeineDaten.vermittlernummer.id')
            ) {
                voucherServices.push(
                    $http({
                        url: AppConfig.INTEGRATION.services.createVouchers,
                        method: 'POST',
                        data: $httpParamSerializerJQLike({
                            p_sid: IntegrationService.getExternalSid(),
                            p_ang_nummer: angebotsnummer,
                            p_ang_token: angebotsToken,
                            p_email_adr: antragstellerEmailPrivat
                        }),
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        cache: false,
                        globalErrorsIgnore: {
                            errors: true,
                            nachrichten: true
                        },
                        httpErrorsIgnore: true,
                        unexpectedErrorsIgnore: true
                    })
                );
            } else {
                voucherServices.push(noopPromise);
            }

            return $q.all(_.filter(voucherServices)).then(function (vouchers) {
                return vouchers;
            }).catch(function (error) {});
        }
        function setRedirectUrlAfterPksLogin(angebot) {
            var AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                redirectUrl = AppConfig.INTEGRATION.redirectUrlAfterPksLogin,
                loginUser = {},
                integrationParams = IntegrationService.getIntegrationParams(),
                vermittlerNummer = _.get(integrationParams, 'mappings["allgemeineDaten.vermittlernummer"].value.id') || $cookies.get('agent_number'),
                netzwerk = _.get(integrationParams, 'mappings["antragsteller.netzwerk"].value.wert') || $cookies.get('nw');

            if (_.isFunction(AngebotSpezifischService.getRedirectUrlAfterPksLogin)) {
                redirectUrl = AngebotSpezifischService.getRedirectUrlAfterPksLogin(angebot);
            }

            try {
                loginUser = JSON.parse($window.localStorage.getItem('loginUser')) || {};
            } catch (e) {
                loginUser = {};
            }
            if (
                loginUser.sid &&
                MiscUtilsService.isEverythingEmpty(integrationParams.angnummer, integrationParams.vertragsnummer, integrationParams.externalSid) &&
                !integrationParams.isTokenLogin
            ) {
                redirectUrl = [
                    redirectUrl,
                    '&p_sid=',
                    loginUser.sid
                ].join('');

                directRedirectLoggedIn = true;
            }
            if (vermittlerNummer && BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT')) {
                redirectUrl += '&p_verm_nr=' + vermittlerNummer;
                _.set(angebot, 'allgemeineDaten.vermittlernummer', IdentityTypeUtilsService.create({
                    type: 'VERMITTLERNUMMER',
                    id: vermittlerNummer,
                    formatiert: vermittlerNummer
                }));
            }
            if (netzwerk && BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT')) {
                if (!_.includes(redirectUrl, '&p_ang_parameter=')) {
                    redirectUrl += '&p_ang_parameter=nw%3D' + netzwerk;
                } else {
                    redirectUrl = redirectUrl.replace('&p_ang_parameter=', '&p_ang_parameter=nw%3D' + netzwerk + '%26');
                }
                _.set(angebot, 'antragsteller.netzwerk', SchluesselWerteUtilsService.create('NETZWERK', netzwerk, netzwerk));
            }

            if ($sessionStorage.reloadAnonym === true) {
                directRedirectLoggedIn = false;
                delete $sessionStorage.reloadAnonym;
            }

            if (!integrationParams.isTokenLogin && $window.sessionStorage) {
                if (!$window.sessionStorage.getItem('iframeReload')) {
                    $window.sessionStorage.setItem('iframeReload', redirectUrl);
                }
                $window.sessionStorage.setItem('reload', true);
            } else {
                directRedirectLoggedIn = false;
            }

            if (directRedirectLoggedIn) {
                $window.parent.confirmBeforeUnload = false;
                $window.parent.removePksRedirectInfos = false;
                $window.location.href = redirectUrl;
            }
        }

        function handleCloseAndNavigation(angebotModel) {
            var subtyp = IntegrationService.getIntegrationParams().subtyp,
                closeUrl = IntegrationService.getIntegrationParams().closeUrl,
                homepageProduktLink,
                payload,
                vertragsnummer = (
                    _.get(angebotModel, 'angebot.vertragsnummerErsatzgeschaeft.id') ||
                    _.get(angebotModel, 'angebot.altvertrag.vertragsnummer.id')
                );

            if (subtyp && AppConfig.APP.urls.produkt[subtyp || 'other']) {
                homepageProduktLink = AppConfig.APP.urls.homepage + '/' + AppConfig.APP.urls.produkt[subtyp || 'other'];
            } else {
                homepageProduktLink = AppConfig.APP.urls.homepage + '/' + AppConfig.APP.urls.produkt;
            }

            $window.confirmBeforeUnload = false;

            if (MiscUtilsService.isAppModus()) {
                payload = {
                    closeWindow: true
                };

                if (closeUrl) {
                    payload.routingType = 'intern';
                    payload.url = _.replace(closeUrl, AppConfig.APP.urls.kundenportal, '');
                } else if (vertragsnummer) {
                    payload.routingType = 'intern';
                    payload.url = '/vertraege/vertrag-details/' + vertragsnummer;
                }

                IntegrationService.sendMessage(payload, _.get($window, 'webkit.messageHandlers.cordova_iab'));
                return;
            } else {
                if ($window.sessionStorage) {
                    $window.sessionStorage.removeItem('iframeReload');
                    $window.sessionStorage.removeItem('reload');
                }

                if (AuthenticationService.isPksLoggedIn() &&
                    AuthenticationService.getSession().tokenLoginSession &&
                    IntegrationService.getIntegrationParams().aufrufer === 'kundenportal'
                ) {
                    if (closeUrl) {
                        $window.location.href = closeUrl;
                        return;
                    }

                    if (vertragsnummer) {
                        $window.location.href = FormatUtilsService.replace(AppConfig.APP.urls.kundenportalVertragDetails, vertragsnummer);
                    } else {
                        $window.location.href = AppConfig.APP.urls.kundenportalStartseite;
                    }
                } else {
                    $window.location.href = homepageProduktLink;
                }
            }
        }

        function getFortsetzenLink(angebot) {
            return FormatUtilsService.replace(AppConfig.APP.urls.fortsetzen, _.get(angebot, 'angebotsnummer.id'), _.get(angebot, 'token'));
        }
    }

})();
